module.exports = __webpack_public_path__ + "img/61_icon.dccb89ad.png";